(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AddConditionDialogController', AddConditionDialogController);

    AddConditionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'AddCondition'];

    function AddConditionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, AddCondition) {
        var vm = this;
        vm.addCondition = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:addConditionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.addCondition.id !== null) {
                AddCondition.update(vm.addCondition, onSaveSuccess, onSaveError);
            } else {
                AddCondition.save(vm.addCondition, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
